/**
 * functions
 */
import { updateLazy } from "Functions/lazy";
import { initTippy } from "Functions/tippy";
import smoothscroll from "smoothscroll-polyfill";

/**
 * common & components
 */
import "Common/smartform";
import "Common/validate-defaults";
import "Common/eshop";
import "Common/window";
import "Common/info-messages";
import "Common/form-addons";
import "Common/admin-bar";
import "Common/cookiebot";
import "Common/age-control";
import "Common/country-select";

import "Common/product-cart-quantity";
import "Common/spinner-quick-update";

import "Components/modal/modal-back";
import "Components/modal/modal-jump";
import "Components/modal/modal-open-from-hash";

/**
 * script
 */
window.Cart.customCallbacks.addedItem = function (form, response) {
    window.rEvent.dispatch("Custom.Cart.addedItem", { form, response });
};
window.Cart.customCallbacks.updatedItem = function (input, response) {
    window.rEvent.dispatch("Custom.Cart.updatedItem", { input, response });
};
window.Cart.customCallbacks.removedItem = function (form, response) {
    window.rEvent.dispatch("Custom.Cart.removedItem", { form, response });
};

window.updateLazy = updateLazy();

document.addEventListener("DOMContentLoaded", () => {
    updateLazy();
    initTippy();
    initTippy(".js-tippy-availability", {
        theme: "availability",
        maxWidth: "520px",
    });
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".js-back").forEach((back) => {
        back.addEventListener("click", (event) => {
            if (event.currentTarget.getAttribute("href") == "#") {
                event.preventDefault();

                window.history.back();
            }
        });
    });
});

smoothscroll.polyfill();

window.customCartRemoveItem = function (element, id) {
    const message = element.getAttribute("data-message") || "Naozaj chcete odstrániť produkt?";
    const confirmText = element.getAttribute("data-confirm-btn") || "Odstrániť";
    const cancelText = element.getAttribute("data-cancel-btn") || "Zrušiť";

    window.Eshop.confirm(
        message,
        {
            confirmButtonText: confirmText,
            denyButtonText: cancelText,
        },
        () => {
            window.location.href = `/remove-item/${id}`;
        }
    );

    element.value = element.lastValidQuantity;

    return false;
};
